import React from "react";

import {
  FormFeedbackCardContainer,
  FormFeedbackCardIconContainer,
  FormFeedbackCardText,
} from "./styles";

const ErrorIcon = require("../../../assets/img/danger-outlined.svg");

interface FormFeedbackCardProps {
  text?: string;
  hide?: boolean;
}

export const FormFeedbackCard = ({ text, hide }: FormFeedbackCardProps) => {
  if (hide) return null;

  return (
    <FormFeedbackCardContainer>
      <FormFeedbackCardIconContainer>
        <img src={ErrorIcon} />
      </FormFeedbackCardIconContainer>
      <FormFeedbackCardText>{text}</FormFeedbackCardText>
    </FormFeedbackCardContainer>
  );
};
